import type { ReactNode } from "react";
import { CheckCircle2, Plus, Save } from "lucide-react";
import type { WeeklyPlanExecutionMode, WeeklyPlanStatus } from "../../../shared/weekly-planning";
import { WeeklyPlanningWorkflowStatus } from "./WeeklyPlanningWorkflowStatus";

export function WeeklyPlanningWorkflowActions(props: {
  status: WeeklyPlanStatus;
  executionMode: WeeklyPlanExecutionMode;
  editable: boolean;
  canEdit: boolean;
  busy: boolean;
  dirty: boolean;
  activationReady: boolean;
  totalHours: number;
  importControl: ReactNode;
  onSave: () => void;
  onDiscard: () => void;
  onOpenActivation: () => void;
  onCreate: () => void;
}) {
  return (
    <section className="weekly-planning-workflow" aria-label="Plan işlemleri">
      <div>
        <strong><WeeklyPlanningWorkflowStatus {...props} /></strong>
        <span>Etkinleştirmeden önce önceki planla farkları inceleyin.</span>
      </div>
      {props.editable ? (
        <div>
          {props.importControl}
          <button type="button" className="primary-button" disabled={!props.dirty || props.busy} onClick={props.onSave}>
            <Save size={16} /> Taslağı kaydet
          </button>
          <button type="button" disabled={props.busy} onClick={props.onDiscard}>Taslağı bırak</button>
          <button type="button" disabled={!props.activationReady} onClick={props.onOpenActivation}>
            <CheckCircle2 size={16} /> Önce/sonra incele
          </button>
        </div>
      ) : props.status === "ACTIVE" && props.canEdit ? (
        <button type="button" className="primary-button" disabled={props.busy} onClick={props.onCreate}>
          <Plus size={16} /> Taslak revizyon oluştur
        </button>
      ) : null}
    </section>
  );
}
